// extracted by mini-css-extract-plugin
module.exports = {"actions":"actions--3TBoW","titleActions":"titleActions--3PWIX"};